<template>
    <div class="backgroud-white cs-courseSchedule-editor">
        <div class="text-center">
            <h4>{{ isAdded?'添加广告': '编辑广告'}}</h4>
        </div>
        <div class="backgroud-gray-popup popup-content-area-small">
            <el-form ref="model" :rules="rules" :model="model" label-width="100px">
                <el-form-item label="学校" prop="universityGroupNumbersArr"  placeholder="请选择投放的学校/组">
                    <el-select :multiple="true" v-model="model.universityGroupNumbersArr">
                      <el-option v-for="item in universityGroups" :key="item.IdValue" :value="item.GroupNumber" :label="item.NameValue">{{item.NameValue}}</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="链接地址" prop="linkUrl">
                    <el-input @change='checkAllInputs' placeholder="图片链接地址" v-model="model.linkUrl" class="input-width" maxlength="256"></el-input>
                </el-form-item>
                <el-form-item label="启用" prop="isActive">
                    <el-checkbox  name="type" v-model="model.isActive"></el-checkbox>
                  </el-form-item>
                  <el-form-item label="广告图片" prop="pictureUrl">
                    <el-button type="text" size="medium" @click="uploadAdvertistingImage()">点击上传广告图片</el-button>
                    <p style="color:#D22">建议尺寸比例 1000 * 600 (像素). 图片大小不能超过 5M</p>
                  </el-form-item>
                  <el-form-item>
                    <image-show
                      :src="model.pictureUrl"
                      :isVisible="advertistingImageShowerVisible"
                    ></image-show>
                  </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer popup-footer">
            <el-row>
                <el-col :span="20" class="footer-left">
                    <span v-if="!showError"></span>
                    <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
                </el-col>
                <el-col class="footer-right" :span="4">
                    <el-button :disabled="submitBtnDisable" type="primary" class="is-plain" @click="save()">{{ isAdded?'确认添加': '保存更新'}}</el-button>
                </el-col>
            </el-row>
        </div>

      <el-dialog
      center
      title="上传广告图片"
      :show-close="true"
      :close-on-click-modal="false"
      width="700px"
      :visible.sync="uploaderModel.visible"
      top="8vh"
      z-index="2000"
    >
      <blob-uploader
        @closeEditor="closeUploader"
        @blobUploadError="onUploaderError"
        @blobUploaded="onUploaderUploaded"
        :type="defaultContainerType"
        :accepts="'.png,.jpg,.jpeg'"
        :isVisible="uploaderModel.visible"
        :isAutoSave="true"
      ></blob-uploader>
    </el-dialog>
  </div>
    
</template>

<style lang="scss" scoped>
</style>

<script>
import { saveAd } from "../../service/studentAd.service";
import blobUploader from "@/components/fileHandler/blobUploader";
import imageShow from "@/components/fileHandler/imageShow";
import { getUniversityGroups } from "../../service/common.service";
export default {
  props: {
    data: {},
    dialogVisible: false
  },
  data() {
      let urlValidator = (rule, value, callback) => {

        let regexp = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        if (value === null || value === '' || regexp.test(value)) {
          return callback();
        }
        return callback(new Error("请输入正确的URL"));
      };
    return {
      defaultContainerType: 14,
      uploaderModel: {
        visible: false,

      },
      model: {
        pictureUrl: "",
        fileStorageId: null,
        linkUrl: "",
        isActive: true,
        imageWidth: 0,
        imageHeight: 0,
        universityGroupNumbersArr: [],
      },
      submitBtnDisable: false,
      isAdded: false,
      showError: false,
      errorMessage: "",
      rules: {
        linkUrl: [
          {
            required: false,
            message:"链接格式不正确",
            trigger: "blur"
          },
          {
            validator: urlValidator,
            trigger: "blur"
          }
        ],
        pictureUrl: [
          {
            required: true,
            message: "必须上传图片",
            trigger: "blur"
          }
        ],
        universityGroupNumbersArr: [
          {
            required: true,
            message: "绑定的学校必选",
            trigger: "change"
          }
        ]
      },
      advertistingImageShowerVisible: false,
      sasKey: null,
      containerName: "",
      containerList: [],
      universityGroups: []
    };
  },
  components: {
     blobUploader,
     imageShow
  },
  created() {
    this.loadData();

    getUniversityGroups(true, false).then((result) => {
       if (!!result && result.success) {
         this.universityGroups = result.data;
       }
    });
  },
  methods: {
    checkAllInputs(value, onlyCheck) {
      let isValid = true;

      if (!this.$refs["model"]) return false;

      this.$refs["model"].validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });

      if (onlyCheck) return isValid;

      this.submitBtnClass = isValid ? "primary" : "info";

      return isValid;
    },
    save() {

      let isValid = this.checkAllInputs(null, true);
      if (!isValid) return false;

      this.submitBtnDisable = true;

      var commitModel = JSON.parse(JSON.stringify(this.model));

      commitModel.Enable = true;

      let result = saveAd(commitModel).then(result => {
        if (!result.success) {
          this.errorMessage = result.message;
          this.showError = true;
        } else {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.showError = false;
          this.$emit("saveSuccess", this.isAdded, result.data);
          this.close();
        }
        this.submitBtnDisable = false;
      });
    },
    close() {
      //this.$refs["model"].resetFields();
      this.$emit("closeDialog");
    },
    loadData() {
      if (!!this.data && !!this.data.Id) {
        this.isAdded = false;
        this.model.id = this.data.Id;
        this.model.pictureUrl = this.data.PictureUrl;
        this.model.isActive = this.data.IsActive;
        this.model.linkUrl = this.data.LinkUrl;
        this.model.imageWidth = this.data.ImageWidth;
        this.model.imageHeight = this.data.ImageHeight;
        this.model.universityGroupNumbersArr = this.data.UniversityGroupNumbersArr;
        this.model.fileStorageId = this.data.FileStorageId;
        this.advertistingImageShowerVisible = true;
      } else {
        this.isAdded = true;
        this.model.id = 0;
        this.model.pictureUrl = "";
        this.model.fileStorageId = 0;
        this.model.isActive = true;
        this.model.linkUrl = "";
        this.model.imageWidth = null;
        this.model.imageHeight = null;
        this.model.universityGroupNumbersArr = [];
        this.advertistingImageShowerVisible = false;
      }
    },
    uploadAdvertistingImage() {
      this.uploaderModel.visible = true;
    },
    getContainerName(type) {
      if (
        !!this.containerList &&
        this.containerList.length > 0
      ) {
        let container = this.containerList.find((i) => i.Key == type);
        if (!!container) {
          this.containerName = container.Value;
        }
      }
    },

    onUploaderError(err) {
      this.$meesage.error("上传失败: " + err);
    },

    closeUploader() {
      this.$nextTick(() => {
        this.uploaderModel.visible = false;
      })
    },

    onUploaderUploaded(file) {
      
      this.model.pictureUrl = file.Path;
      this.model.fileStorageId = file.FileId;

      this.advertistingImageShowerVisible = true;
      this.closeUploader();
    }



  },
  watch: {
    data: function() {
      this.loadData();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/studentAdvertisement/adEdit.vue